import { render, staticRenderFns } from "./MapOverlay.global.vue?vue&type=template&id=5faf37af&lang=pug&"
import script from "./MapOverlay.global.vue?vue&type=script&lang=ts&"
export * from "./MapOverlay.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports